import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '~env/environment';

@Injectable()
export class L10nClientInterceptor implements HttpInterceptor {
  constructor(@Inject(LOCALE_ID) protected localeId: string) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isLoadBee =  request.url.includes('availability.loadbee.com');
    if (this.isCDNUrl(request.url) || isLoadBee || this.isStorageBucketUrl(request.url)) {
      return next.handle(request);
    }

    if (this.localeId) {
      request = request.clone({
        setHeaders: {
          'Accept-Language': this.localeId,
          'Content-Language': this.localeId,
        }
      });
    }

    return next.handle(request);
  }

  private isCDNUrl(requestUrl: string): boolean {
    return  requestUrl.startsWith(environment.cdnBaseUrl());
  }

  private isStorageBucketUrl(requestUrl: string): boolean {
    return requestUrl.startsWith(environment.svcStorageBucketUrl());
  }
}
